//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import type { SearchSubscriptionAlertRequest } from './models/SearchSubscriptionAlertRequest';
import type { SearchSubscriptionAlertResponse } from './models/SearchSubscriptionAlertResponse';
import { Utilities } from './Utilities';

export class AlertsClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        searchAlerts: (): string => {
            let clientRequestUrl = '/api/v1/alerts/do-search';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    };

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Search subscription alerts
     * @param body (optional) 
     * @return OK
     */
    async searchAlerts(
        body?: SearchSubscriptionAlertRequest,
    ): Promise<SearchSubscriptionAlertResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.searchAlerts();

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<SearchSubscriptionAlertResponse>(_response, false, []);
    }
}
